import { render } from "./CommissionRecord.vue?vue&type=template&id=313da612"
import script from "./CommissionRecord.vue?vue&type=script&lang=js"
export * from "./CommissionRecord.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__